"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
export class ErrorWithResponse extends Error {
  constructor(message, response) {
    super(message);
    __publicField(this, "response");
    this.response = response;
  }
}
export function isJqXHR(error) {
  return typeof error === "object" && error !== null && "getResponseHeader" in error;
}
export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  throw new ErrorWithResponse(response.statusText, response);
}
const parseJSON = (response) => {
  if (response.status === 204) {
    return "";
  }
  return response.json();
};
const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
const getBody = (opts, method) => {
  if (method.toUpperCase() !== "GET") {
    if (opts.body) {
      return opts.body;
    } else if (opts.data) {
      return JSON.stringify(opts.data);
    }
  }
};
const getUrl = (url, opts, method) => {
  if (method.toUpperCase() !== "GET" || !opts.data) {
    return url;
  }
  const paramStr = $.param(opts.data);
  return `${url}?${paramStr}`;
};
const fetchWrapped = (url, opts = {}) => {
  const headers = Object.assign({}, defaultHeaders, opts.headers || {});
  const method = opts.method || "get";
  const body = getBody(opts, method);
  const fullUrl = getUrl(url, opts, method);
  return fetch(fullUrl, __spreadProps(__spreadValues({}, opts), {
    method,
    headers,
    body,
    credentials: "include"
  })).then(checkStatus).then((res) => parseJSON(res));
};
export default fetchWrapped;
